<script setup>
import { VueFinalModal } from 'vue-final-modal'
import { X } from 'lucide-vue-next'
import { useTranslations } from '@/translation'

const emit = defineEmits(['update:modelValue'])
const { t } = useTranslations()
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    overlay-class="!bg-backdrop-color"
    content-class="flex flex-col max-w-xl mx-4 p-4  rounded-lg space-y-2 bg-app text-primary h-auto max-h-[90vh] w-full relative"
    content-transition="vfm-slide-down"
    overlay-transition="vfm-fade"
    @update:model-value="(val) => emit('update:modelValue', val)"
  >
    <!-- Close button -->
    <button
      type="button"
      class="absolute top-3 right-3 z-10 p-2 rounded-full bg-transparent hover:bg-gray/10 focus:bg-gray/10 focus:outline-none focus:ring-2 focus:ring-primary/50 transition-colors duration-200"
      :aria-label="t('aria.closeModal')"
      @click="() => emit('update:modelValue', false)"
    >
      <X />
    </button>

    <div class="overflow-auto" @click.self="() => emit('update:modelValue', false)">
      <div class="flex w-full h-full flex-col w-full max-w-xl mx-auto p-4 rounded-lg space-y-2">
        <slot />
      </div>
    </div>
  </VueFinalModal>
</template>
